import { render, staticRenderFns } from "./choosePointDialog.vue?vue&type=template&id=51b0c5cd&scoped=true&"
import script from "./choosePointDialog.vue?vue&type=script&lang=js&"
export * from "./choosePointDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0c5cd",
  null
  
)

export default component.exports